import React from 'react';
import { AppState } from '../App';

export const AppContext = React.createContext<AppState>({
    locale: "fr",
    switchLanguage: (value: string) => { },
});